import React from 'react';

import { RecipientListV2 } from './recipient-list-v2';

type RecipientListProps = {
  marketingCampaignId: string;
};

export function RecipientList({ marketingCampaignId }: RecipientListProps) {
  return <RecipientListV2 marketingCampaignId={marketingCampaignId} />;
}
